angular.module('bmsApp.directives')

    .directive('datePicker', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {

                var config;
                var storageFormat;
                var datePicker = scope.$eval(attrs.datePicker);
                var events = scope.$eval(attrs.events);

                element.attr('autocomplete', 'off').attr('readonly', 'readonly');

                if (angular.isUndefined(datePicker.options)) {
                    throw new Error("DateRangePicker expects an 'options' object");
                }

                config = datePicker.options;
                storageFormat = datePicker.storageFormat;
                var singlePicker = config.singleDatePicker;
                var instance = element.daterangepicker(config);

                if (!angular.isUndefined(events)) {
                    angular.forEach(events, function (handler, event) {
                        instance.on(event, handler);
                    });
                }


                // bind the given event handlers
                angular.forEach(datePicker.eventHandlers, function (handler, event) {
                    instance.on(event, handler);
                });

                scope.$watch(attrs.datePicker, function (newOptions) {
                    if (angular.isDefined(newOptions)) {
                        instance = element.daterangepicker(newOptions.options);
                    }
                }, true);

                // Close if the state changes
                scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
                    instance.data('daterangepicker').container.css('display', 'none');
                });

                function fromFormatted(date) {
                    if (!angular.isUndefined(date) && date !== null) {
                        if (typeof date === 'string' && date.length) {
                            if (singlePicker) {
                                return instance.data('daterangepicker').endDate.format(storageFormat);
                            }
                            else {
                                return {
                                    startDate: instance.data('daterangepicker').startDate.format(storageFormat),
                                    endDate: instance.data('daterangepicker').endDate.format(storageFormat)
                                };
                            }
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                }

                function toFormatted(date) {
                    if (!angular.isUndefined(date) && date !== null) {
                        if (singlePicker) {
                            var endDateMoment = moment(date, storageFormat);
                            instance.data('daterangepicker').setEndDate(endDateMoment);
                            return endDateMoment.format(config.format);
                        }
                        else {
                            if (angular.isDefined(date.startDate)) {
                                var startDateMoment = moment(date.startDate, storageFormat);
                                var endDateMoment = moment(date.endDate, storageFormat);
                                instance.data('daterangepicker').setStartDate(startDateMoment);
                                instance.data('daterangepicker').setEndDate(endDateMoment);
                                return startDateMoment.format(config.format) + ' - ' + endDateMoment.format(config.format);
                            }

                        }
                    }
                    else {
                        return null;
                    }
                }

                ngModel.$parsers.push(fromFormatted);
                ngModel.$formatters.push(toFormatted);

                instance.on('apply.daterangepicker', function (ev, picker) {
                    if (singlePicker) {
                        ngModel = picker.endDate.format(storageFormat);
                    }
                    else {
                        ngModel = {
                            startDate: picker.startDate.format(storageFormat),
                            endDate: picker.endDate.format(storageFormat)
                        };
                    }
                    // Trigger validation
                    if (typeof picker.element.valid == 'function') {
                        picker.element.valid();
                    }
                });

            }

        };
    });
      